<template>
  <div id="registrationSuccessful">
    <Background-Image url="na-praia.jpg" lowResUrl="na-praia-lowres.jpg" color="#0288D1"></Background-Image>
    <Navigation></Navigation>
    <div class="container-fluid">
      <div class="row">
        <div class="offset-md-3 col-md-6">

          <!--Panel-->
          <div class="m-t-6 card text-xs-center">
            <div class="card-header default-color-dark white-text">
              {{t('Registration')}}
            </div>
            <div class="card-block">
              <h4 class="card-title">{{t('Thank you for registering')}}</h4>
              <p class="card-text">
                {{t('You should be receiving an account activation email shortly')}}
              </p>
              <a class="btn btn-default" id="registrationSuccessClose" v-on:click="redirectHome">{{t('Home')}}</a>
              <a :href="lastActivity" v-if="lastActivity" class="btn btn-default" id="registrationSuccessClose" >{{t('Go to last visited activity')}}</a>
            </div>
            <!--div class="card-footer text-muted default-color-dark white-text">
              <p>2 days ago</p>
            </div-->
          </div>
          <!--/.Panel-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import Navigation from '../Navigation/Navigation';
  import BackgroundImage from '../BackgroundImage';

  export default {
    name: 'RegistrationSuccess',
    components: {
      'Background-Image': BackgroundImage,
      Navigation,
    },
    data() {
      return {};
    },

    computed: {
      ...mapState({
        lastActivity: state => state.activityPublic.lastVisitedActivityUrl,
      }),
    },
    methods: {
      redirectHome() {
        this.$router.push(`/${this.$store.state.language}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
  #registrationSuccessful {
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// RegistrationSuccess.vue?66163d68